<template>
  <div class="header-child header-blue">
    Weekly Attendance
  </div>

  <div class="content-base" v-if="loadData === false">
    <div class="this-list" :class="valueDaily.showAll === child.student_name ? '' : 'data-hide'" v-for="child in dataDaily.value" :key="child.student_name">
      <div class="child-name">
        <p>{{ child.student_name }}</p>
      </div>

      <div v-if="child.data">
        <div class="data-list" v-for="data in child.data" :key="data.name_siswa" @click.capture="detailClickWeek(data)" :class="[data.status === 'Hadir' ? 'subject-check' : '', data.status === 'Izin' || data.status === 'Sakit' ? 'subject-disable' : '', data.status === 'Alpa' ? 'subject-cross' : '', data.ket_hri === 'Sunday' ? 'subject-disable' : '', data.name_siswa === child.student_name ? 'padding-data' : '', data.late_check >= 1 ? 'subject-cross' : '']">
          <div class="subject-time" style="padding-bottom: 100px !important;" :class="[(data.status === 'Hadir') && (data.ket_hri !== 'Sunday') ? 'data-success' : '', (data.status === 'Izin') && (data.ket_hri !== 'Sunday') ? 'data-primary' : '', (data.status === 'Sakit') && (data.ket_hri !== 'Sunday') ? 'data-primary' : '', (data.status === 'Alpa') && (data.ket_hri !== 'Sunday') ? 'data-danger' : '', data.late_check >= 1 ? 'data-danger' : '', data.ket_hri === 'Sunday' ? 'data-disable' : '']">
            <p v-if="(data.status === 'Hadir') &&  data.ket_hri !== 'Sunday'" class="success-text">
              Present
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="data.status === 'Hadir' && data.ket_hri !== 'Sunday'">
                <path d="M99.9998 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 99.9998 16.6667C54.1665 16.6667 16.6665 54.1667 16.6665 100C16.6665 145.833 54.1665 183.333 99.9998 183.333Z" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M64.5835 100L88.1668 123.583L135.417 76.4167" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>
            <p v-else-if="(data.status === 'Izin' || data.status === 'Sakit') &&  data.ket_hri !== 'Sunday'" class="primary-text">
              {{ data.status === 'Izin' ? 'Permission' : 'Sick' }}
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="data.status === 'Izin' && data.ket_hri !== 'Sunday' || data.status === 'Sakit' && data.ket_hri !== 'Sunday'">
                <path d="M183.333 83.3333V125C183.333 166.667 166.667 183.333 125 183.333H75.0001C33.3334 183.333 16.6667 166.667 16.6667 125V75C16.6667 33.3333 33.3334 16.6667 75.0001 16.6667H116.667" stroke="#43A5FF" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M58.3333 108.333H108.333M58.3333 141.667H91.6666M183.333 83.3333H150C125 83.3333 116.667 75 116.667 50V16.6667L183.333 83.3333Z" stroke="#43A5FF" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>
            <p v-else-if="(data.status === 'Alpa') &&  data.ket_hri !== 'Sunday'" class="danger-text">
              Absent
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="data.status === 'Alpa' && data.ket_hri !== 'Sunday'">
                <path d="M76.4165 123.583L123.583 76.4167M123.583 123.583L76.4165 76.4167M99.9998 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 99.9998 16.6667C54.1665 16.6667 16.6665 54.1667 16.6665 100C16.6665 145.833 54.1665 183.333 99.9998 183.333Z" stroke="#E35D5B" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>
            <p v-else-if="data.ket_hri === 'Sunday'">
              Off Day
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="disable-text">
                <path d="M66.6668 16.6667V41.6667M133.333 16.6667V41.6667M29.1667 75.75H170.833M158.917 167.583L141.25 150M158.75 150.167L141.083 167.833M150 191.667C158.841 191.667 167.319 188.155 173.57 181.904C179.822 175.652 183.333 167.174 183.333 158.333C183.333 149.493 179.822 141.014 173.57 134.763C167.319 128.512 158.841 125 150 125C141.16 125 132.681 128.512 126.43 134.763C120.179 141.014 116.667 149.493 116.667 158.333C116.667 167.174 120.179 175.652 126.43 181.904C132.681 188.155 141.16 191.667 150 191.667Z" stroke="#4B4B4B" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M175 70.8334V136.333C168.917 129.417 160 125 150 125C131.583 125 116.667 139.917 116.667 158.333C116.667 164.583 118.417 170.5 121.5 175.5C123.25 178.5 125.5 181.167 128.083 183.333H66.6667C37.5 183.333 25 166.667 25 141.667V70.8334C25 45.8334 37.5 29.1667 66.6667 29.1667H133.333C162.5 29.1667 175 45.8334 175 70.8334Z" stroke="#4B4B4B" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M99.9584 114.167H100.042M69.1167 114.167H69.2M69.1167 139.167H69.2" stroke="#4B4B4B" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>

            <p v-if="!data.is_special" class="important-text">{{ formatDay(data.date) }}</p>
            <p v-if="!data.is_special">{{ formatDate(data.date) }}<br>{{ data.jam }}</p>

            <p v-if="data.is_special" class="important-text">{{ data.ket }}</p>
            <p v-if="data.is_special">{{ data.date }}</p>
            <!-- <p v-if="data.ket_hri !== 'Sunday' || data.status !== 'Izin' || data.status !== 'Sakit' || data.status !== 'Alpa'">{{ data.jam }}</p> -->
          </div>
        </div>
      </div>

      <div :class="[child.data.filter(item => item.name_siswa === child.student_name).length > 1 ? 'more-data' : '']" v-show="valueDaily.showAll !== data.name_siswa && child.data.filter(item => item.name_siswa === child.student_name).length > 1" v-for="data in child.data" :key="data.name_siswa">
        <div class="btn-show-all" v-if="[child.data.filter(item => (item.name_siswa === child.student_name)).length > 1]" @click="clickAll(data.name_siswa)">Show all</div>
      </div>

      <!-- No data -->
      <!-- .filter(item => item.hri >= valueDaily.firstWeek && item.hri <= valueDaily.lastWeek) -->
      <div v-if="child.data == 0" class="nodata-list">
        No Data!
      </div>

      <!-- <div class="nodata-list" v-else-if="dataOut.value.filter(item => [(item.name_siswa === child.student_name) && (item.hri >= valueDaily.firstWeek && item.hri <= valueDaily.lastWeek)]).length == 0">
        <p>No Data!</p>
      </div> -->

      <div v-else :class="data.name_siswa !== child.student_name ? 'nodata-list' : ''" v-for="data in child.data" :key="data.name_siswa">
        <p v-if="data.name_siswa !== child.student_name">No Data!</p>
      </div>
    </div>
  </div>

  <!-- Input end date -->
  <div class="content-base flex justify-center" v-if="loadData === false">
    <jb-button label="More" color="info" small @click="SearchPeriod()" class="w-auto md:w-2/3 mx-auto md:mx-0 md:-ml-1 rounded-xl md:rounded py-2 px-8 mb-6 md:mb-0" />
  </div>

  <!-- Load data -->
  <div v-if="loadData === true" class="this-loader" :class="loadData === true ? 'lay-load' : ''">
    <data-loader />
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUpdated, watchEffect, watch, computed } from 'vue';
  import axios from 'axios'
  import JbButton from '@/components/JbButton'
  import dayjs from 'dayjs';
  import { mdiCalendar } from '@mdi/js'
  import { useRouter } from 'vue-router'

  import DataLoader from '../../../components/Animation/DataLoader.vue';

  export default {
    name: "Menu Preview",
    components: {
      JbButton,
      DataLoader
    },
    props: {
      propFilter: {
        type: Object,
        default: () => ({ empty: true })
      }
    },
    methods: {
      //  Format for date (1 January 2023)
      formatDate(dateString) {
        const date = dayjs(dateString);
        return date.format('D MMMM YYYY');
      },

     // Fromat day
      formatDay(dateString) {
        const date = dayjs(dateString);
        return date.format('dddd');
      },

      // Format IDR (2.000.000)
      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    setup(props, {emit}) {
      // Load data
      const loadData = ref(true)

      // Get daily
      const methodDaily = 'GET'
      const urlDaily = 'getreportdailyparentoneweek'
      const valueDaily = reactive({
        department_id: "",
        academic_year_id: "",
        level_id: "",
        class_id: "",
        classteacher_id: "",
        employee_id: "",
        homeroom: true,
        student_id: "",
        student_name: "",
        student_class: "",
        month_id: "",
        month_name: "",
        parent_id: localStorage.getItem('user_id'),
        firstWeek: "",
        lastWeek: "",
        showAll: ""
      });
      const dataDaily = reactive({})

      // Get data daily
      const getDaily = async () => {
        loadData.value = true

        const date = new Date();
        valueDaily.month_id = (date.getMonth() + 1).toString().padStart(2, "0");

        await axios({
            method: methodDaily,
            url: urlDaily,
            params: valueDaily
        })
        .then(response => {
          dataDaily.value = response.data.data
          loadData.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      const getWeek = () => {
        var curr = new Date;
        var first = curr.getDate() - curr.getDay() + 1;
        var last = first + 6;

        var firstday = new Date(curr.setDate(first));
        var lastday = new Date(curr.setDate(last));

        var getdatefirst = firstday.getDate()
        var getdatelast = lastday.getDate()

        // valueDaily.firstWeek = getdatefirst
        // valueDaily.lastWeek = getdatelast
      }

      const detailClickWeek = (event) => {
        emit("detail-click", event)
      }

      const clickAll = (data) => {
        valueDaily.showAll = data
      }

      const router = useRouter()
      const SearchPeriod = (event) => {
        // emit("search-period", event)
        router.push('/parent/attendance')
      }

      watch(() => props.propFilter, (newVal, oldVal) => {
        console.log('props.propFilter watch', props.propFilter)

        if(props.propFilter){
          valueDaily.firstWeek = props.propFilter.firstWeek
          valueDaily.lastWeek = props.propFilter.lastWeek
          getDaily()
        }
      })
      watchEffect(() => {
        // console.log('props.propFilter watchEffect', props.propFilter)
      })

      onMounted(() => {
        // getWeek()
        getDaily()
      })

      return {
        SearchPeriod,
        mdiCalendar,
        clickAll,
        detailClickWeek,
        methodDaily,
        urlDaily,
        valueDaily,
        dataDaily,
        loadData,
        getWeek
      }
    }
  }
</script>

